export default (cta) => ({
    parentEl: null,
    textClasses: '',
    btnClasses: 'btn-primary',

    init() {
        const columnClasses = [
            cta.colSpan === 2 ? 'lg:col-span-2' : '',
            cta.colSpan === 4 ? 'lg:col-span-4 lg:aspect-[1/0.34]'
            : 'lg:aspect-auto',
        ].filter(Boolean)
        .map((c) => c.split(' '))
        .flat()

        this.$root.parentElement.classList.add(...columnClasses)

        this.textClasses = [
            cta.textColour === 'white' ? 'text-white' : 'text-body',
            cta.uppercase ? 'uppercase' : '',
            cta.increaseSummaryFontSize ? 'text-lg' : '',
        ].join(' ')
    },
})
